/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PspChannel } from "./PspChannel";
import * as t from "io-ts";

// required attributes
const PspChannelListR = t.interface({
  channels: t.readonlyArray(PspChannel, "array of PspChannel")
});

// optional attributes
const PspChannelListO = t.partial({});

export const PspChannelList = t.intersection(
  [PspChannelListR, PspChannelListO],
  "PspChannelList"
);

export type PspChannelList = t.TypeOf<typeof PspChannelList>;
